import {
  getPaginatedProductsApi,
  getProductOptionsApi,
  createPackTypeAssignmentApi,
  getProductPackTypeAssignmentsApi,
  getProfileDetailsApi,
  getTransporterListApi,
} from 'src/api/settingApi';

import {
  SETTINGS_ICON_ACTIVE_TOGGLE,
  GET_PAGINATED_PRODUCTS,
  GET_PRODUCT_OPTIONS,
  CREATE_PACK_TYPE_ASSIGNMENT,
  GET_PRODUCT_PACK_TYPE_ASSIGNMENTS,
  GET_PROFILE_DETAILS,
  GET_TRANSPORTER_LIST,
  SET_PROFILE_IMAGE,
} from 'src/redux/Actions/Type';

export const handleSettingsIconActiveToggle = (data) => ({
  type: SETTINGS_ICON_ACTIVE_TOGGLE,
  payload: data,
});

export function getPaginatedProducts(tenantId, searchTerm) {
  return (dispatch) => {
    getPaginatedProductsApi(tenantId, searchTerm).then((data) => {
      dispatch({
        type: GET_PAGINATED_PRODUCTS,
        payload: data,
      });
    });
  };
}

export function getProductOptions(
  tenantOrganisationId,
  searchTerm,
  pageNumber = 1,
  paginationBatchSize = 10,
) {
  return (dispatch) =>
    getProductOptionsApi(
      tenantOrganisationId,
      searchTerm,
      pageNumber,
      paginationBatchSize,
    ).then((data) => {
      dispatch({ type: GET_PRODUCT_OPTIONS, payload: data });
      return data;
    });
}

export const createPackTypeAssignment = (createData) => (dispatch) =>
  createPackTypeAssignmentApi(createData).then((data) => {
    dispatch({
      type: CREATE_PACK_TYPE_ASSIGNMENT,
      payload: data,
    });
    return Promise.resolve(data);
  });

export function getProductPackTypeAssignments(
  tenantOrganisationId,
  pageNumber,
  queryString,
) {
  return (dispatch) =>
    getProductPackTypeAssignmentsApi(
      tenantOrganisationId,
      pageNumber,
      queryString,
    ).then((data) => {
      dispatch({
        type: GET_PRODUCT_PACK_TYPE_ASSIGNMENTS,
        payload: data,
      });
      return Promise.resolve(data);
    });
}

export const getProfileDetails = (tenantId, profileId) => (dispatch) =>
  getProfileDetailsApi(tenantId, profileId).then((data) => {
    dispatch({
      type: GET_PROFILE_DETAILS,
      payload: data,
    });

    if (!data?.profilePictureUrl) {
      dispatch({
        type: SET_PROFILE_IMAGE,
        payload: null,
      });
      return data;
    }

    return fetch(data.profilePictureUrl)
      .then((res) => res.blob())
      .then(
        (blob) =>
          new Promise((resolve) => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = () => {
              dispatch({
                type: SET_PROFILE_IMAGE,
                payload: reader.result,
              });
              resolve(data);
            };
          }),
      );
  });

export function getTransporterList(
  tenantOrganisationId,
  pageNumber,
  searchInput,
  tableFieldFilter,
  paginationBatchSize,
  queryString,
) {
  return (dispatch) =>
    getTransporterListApi(
      tenantOrganisationId,
      pageNumber,
      searchInput,
      tableFieldFilter,
      paginationBatchSize,
      queryString,
    ).then((data) => {
      dispatch({
        type: GET_TRANSPORTER_LIST,
        payload: data,
      });
      return data;
    });
}
